import InAppMessage from "./in-app-message";
import { TMessageType } from './interfaces';

export { TMessageType };
export default InAppMessage;

